<template>
  <div class="footContainer">
      <div class="box1" @click="toIndex">
        <div>
          <img src="../assets/index.png" width="50px;">
        </div>
        <div class="menuTitle">首页</div>
      </div>

      <div class="box2" @click="toStudy">
        <div>
          <img src="../assets/study.png" width="45px;">
        </div>
        <div class="menuTitle">学习中心</div>
      </div>

      <div class="box3" @click="toMine">
        <div>
          <img src="../assets/mine.png" width="45px;">
        </div>
        <div class="menuTitle">我的</div>
      </div>
  </div>
</template>

<script>
    export default {
        name: "footer",
        methods:{
          toIndex(){
            this.$router.push('/home');
          },
          toStudy(){
            this.$router.push('/study');
          },
          toMine(){
            this.$router.push('/mine');
          }
        }
    }

</script>

<style scoped>

  @import "../assets/fonts/font.css";
  .footContainer{
    position: fixed;
    background-color: #ffffff;
    /*opacity: 50%;*/
    width: 100%;
    height: 12%;
    bottom: 0;
    display: flex;
    border-top: #00000038 solid 1px;
  }

  .box1{
    /*margin-left: 20px;*/
    width: 20%;
    margin-top: 15px;
    cursor: pointer;

  }

  .box2{
    position: fixed;
    margin-left: 40%;
    width: 20%;
    margin-top: 15px;
    cursor: pointer;
  }

  .box3{
    position: fixed;
    /*margin-left: 20px;*/
   right: 0;
    /*margin-right: 20px;*/
    width: 20%;
    margin-top: 15px;
    cursor: pointer;
  }
  .menuTitle{
    /*position: fixed;*/
    font-family: myMind;
    font-size: 20px;
    bottom: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue